import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useNotifications, formatRelativeTime } from '../../context/NotificationContext';

const PREVIEW_COUNT = 8;

const NotificationBell = () => {
  const { notifications, unreadCount, loading, markAsRead, markAllAsRead } = useNotifications();
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (!open) return;
    const handler = (e) => {
      if (e.key === 'Escape') { setOpen(false); return; }
      if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handler);
    document.addEventListener('keydown', handler);
    return () => {
      document.removeEventListener('mousedown', handler);
      document.removeEventListener('keydown', handler);
    };
  }, [open]);

  const handleItemClick = (notification) => {
    if (!notification.is_read) markAsRead(notification.id);
    setOpen(false);
    if (notification.opportunity) navigate(`/opportunity/details/${notification.opportunity}`);
  };

  const preview = notifications.slice(0, PREVIEW_COUNT);

  return (
    <div className="notif-bell-wrap" ref={wrapRef}>
      <button
        className="top-header-icon-btn notif-bell-btn"
        type="button"
        aria-label="Notifications"
        onClick={() => setOpen(o => !o)}
      >
        🔔
        {unreadCount > 0 && (
          <span className="notif-badge">{unreadCount > 99 ? '99+' : unreadCount}</span>
        )}
      </button>

      {open && (
        <div className="notif-dropdown">
          <div className="notif-dropdown-header">
            <span>Notifications</span>
            {unreadCount > 0 && (
              <button type="button" className="notif-mark-all" onClick={markAllAsRead}>
                Mark all read
              </button>
            )}
          </div>

          <div className="notif-dropdown-list">
            {loading && preview.length === 0 ? (
              <div className="notif-dropdown-empty">Loading…</div>
            ) : preview.length === 0 ? (
              <div className="notif-dropdown-empty">No notifications yet</div>
            ) : (
              preview.map(n => (
                <div
                  key={n.id}
                  className={`notif-item${n.is_read ? '' : ' notif-item-unread'}`}
                  onClick={() => handleItemClick(n)}
                >
                  <span className="notif-item-dot" />
                  <div className="notif-item-body">
                    <div className="notif-item-message">{n.message}</div>
                    {n.opportunity_name && (
                      <div className="notif-item-meta">{n.opportunity_name}</div>
                    )}
                    <div className="notif-item-time">{formatRelativeTime(n.created_at)}</div>
                  </div>
                </div>
              ))
            )}
          </div>

          <button
            type="button"
            className="notif-dropdown-footer"
            onClick={() => { setOpen(false); navigate('/notifications'); }}
          >
            View all notifications
          </button>
        </div>
      )}
    </div>
  );
};

export default NotificationBell;
